<template>
    <el-container style='height:100%'>
            <el-aside width="230px" style="background-color: rgb(238, 241, 246)">
                <div class='brand'>
                    POWERTEHCNIC MAIL
                </div>
                    <el-menu :default-active="activeIndex" @select="handleSelect">
                        <el-menu-item index='main'>
                            <el-icon name='user'></el-icon>
                            <span>Email Account</span>
                        </el-menu-item>
                        <el-menu-item index='forward'>
                            <el-icon name='message'></el-icon>
                           <span>Mail Forwarder</span>
                        </el-menu-item>
                    </el-menu>
            </el-aside>
        <el-container>
          <el-header>
            <span class='brand'></span>
        </el-header>
        <el-main id='el-main-container' style='height:100%;'>
            <slot></slot>
        </el-main>
        
        </el-container>
        <div class='loader' v-if='loading'>Loading</div>
    </el-container>
</template>

<script>
export default {
        data(){
            return {
                activeIndex:'main',
                loading: false
            };
        },
        methods:{

            handleSelect(menu){
                localStorage.setItem('current_menu',menu);
                this.$router.replace({name: menu});
            }
        },
        mounted(){

                app.$on('show-loading', ()=>{
                    this.loading = true;
                });


                app.$on('hide-loading', ()=>{
                    this.loading = false;
                })

                let menu = localStorage.getItem('current_menu');
                if(menu != undefined && menu != null)
                    this.activeIndex = menu;
        }
}
</script>

<style lang='scss'>

.loader{
    position:fixed;
    top:5px;
    width: 100px;
    background: #5ea6ff;
    color: #FFF;
    left:-webkit-calc(50% - 50px);
    left:-moz-calc(50% - 50px);
    left:calc(50% - 50px);
    padding: 10px 5px;
    text-align:center;
}

.brand{
    height:60px;
    line-height: 60px;
    font-weight: bold;
    padding-left:20px;
    font-size:15px;
    color: #AAA;
    background:  #EEE;
}
            .el-header{
            background: #EEE;
            .brand{
                    line-height: 60px;
                    color: #888;
                    font-weight: bold;
            }
        }

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue